import React from "react";

const BowlingStrikeIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <ellipse cx="12.4" cy="7.6" rx="1.05" ry="3.05" />
    <circle cx="12.4" cy="5" r="1.15" />
    <ellipse cx="15.35" cy="7.6" rx="1.05" ry="3.05" />
    <circle cx="15.35" cy="5" r="1.15" />
    <ellipse cx="13.9" cy="5.35" rx="1.1" ry="3.15" />
    <circle cx="13.9" cy="2.7" r="1.2" />
    <path
      fillRule="evenodd"
      d="M6.15 8.2a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-1 2.15a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6zm1.85.2a.65.65 0 1 0 0 1.3.65.65 0 0 0 0-1.3zm-.5 1.75a.65.65 0 1 0 0 1.3.65.65 0 0 0 0-1.3z"
      clipRule="evenodd"
    />
  </svg>
);

export default BowlingStrikeIcon;
